import { APIConfiguration } from '@savgroup-front-common/configuration';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.workflow}files/customerfile/referencesfromfile`;

export interface FileBaseSummaryDto {
  fileId: string;
  fileReference?: string;
  sellerId?: string;
}

interface GetFilesByRefFromFileCommandArgs {
  file: File;
}

const getFilesByRefFromFileCommand = async ({
  file,
}: GetFilesByRefFromFileCommandArgs): Promise<
  BackResponse<FileBaseSummaryDto[]> | BackResponseFailure
> => {
  try {
    const body = new FormData();

    body.append('File', file);

    return await apiCall<BackResponse<FileBaseSummaryDto[]>>(ENDPOINT, {
      method: SUPPORTED_METHODS.POST,
      body,
    });
  } catch (exception) {
    return prepareResponseFailure(exception);
  }
};

export default getFilesByRefFromFileCommand;
